export const formatPaxName = (pax) => {
  let firstName = pax.FirstName[0] + pax.FirstName.slice(1).toLowerCase()
  let lastName = pax.LastName[0] + pax.LastName.slice(1).toLowerCase()
  return firstName + ' ' + lastName
}